<div class="popin-cancel-subscription">
	<stripe-subscription-cancel-alert
		id="stripe-subscription1"
	>
		<div class='notice-warning'>
			<p class="text-left">
				<i18n :path="'vm.components.popin.stripe-subscription-cancel.alert1'" tag="p">
					<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
						<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
					</svg>

				</i18n>
			</p>
		</div>
	</stripe-subscription-cancel-alert>
	<h2>{{ $t('vm.components.popin.stripe-subscription-cancel.question')}}</h2>

	<div class="reasons">
			<radio-frame v-for="reason in reasons" :key="`reason-${reason.value}`" :id="`reason-${reason.value}`" :name="`reason-group`"
			v-model="selectedReason"
			:radio-value="reason.value"
			default-class="p-like"
			>
			{{ reason.label }}
			</radio-frame>

	</div>

	<div v-if="selectedReason === 'other'" class="other-reason">
		<textarea-frame id="other" v-model="otherText" class="grid-item-full"
					 :label="$t('vm.components.popin.stripe-subscription-cancel.other.label')"
					 :placeholder="$t('vm.components.popin.stripe-subscription-cancel.other.placeholder')"
					 :title="$t('vm.components.popin.stripe-subscription-cancel.other.title')"
					 :errorMsg="message" />

	</div>


	<p class="legal-text">

		<stripe-subscription-cancel-alert
			id="stripe-subscription2"
		>
			<div class='notice-warning'>
				<p class="text-left">
					<i18n :path="'vm.components.popin.stripe-subscription-cancel.alert2'" tag="p">
						<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
							<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
						</svg>

					</i18n>
				</p>
			</div>
		</stripe-subscription-cancel-alert>

	</p>

</div>
